import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy WordPress test page — permanently redirect to the homepage.
export const Route = createFileRoute("/clone-of-formidable-test-page-2")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
